import Group, { GroupList } from "@/models/api/group/Group";
import GroupRegistrationRequest from "@/models/api/group/GroupRegistrationRequest";

import axios, { AxiosResponse } from "axios";

class Service {
    public async EditGroup(association: Group): Promise<AxiosResponse<any>> {
        return axios.post("api/group/EditGroup", association);
    }
    public async GetGroups(): Promise<AxiosResponse<GroupList[]>> {
        return axios.get('api/group/GetGroups/');
    }
    public async GetGroup(id: number): Promise<AxiosResponse<any>> {
        return axios.get(`api/group/${id}`);
    }
    public async RegisterGroup(associationData: GroupRegistrationRequest): Promise<AxiosResponse<any>> {
        return axios.post("api/group/RegisterGroup", associationData);
    }

    public async RemoveGroup(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/group/RemoveGroup?id=${id}`);
    }
}

export const GroupService: Service = new Service();
